/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($) {
	/*
	 * Dependencies:
	 * TerrificJs 2.0.1,
	 * jQuery 1.7 or greater,
	 * jquery.placeholder.min.js,
	 *
	 */

	'use strict';
	/*globals Tc */
	/*jshint smarttabs:true */

	Tc.Module.LoadingIndicator = Tc.Module.extend({

		init: function($ctx, sandbox, modId) {
			var mod = this;
			mod.$ctx = $ctx;
			mod.properties = {
				interval: mod.$ctx.data('interval') || 500,
				checkVisibility: mod.$ctx.data('check-visibility')
			};
			this._super($ctx, sandbox, modId);
		},

		on: function(callback) {
			var mod = this;
			mod.$ctx.on('stop', function(){
				mod.properties.checkVisibility = false;
			});
			callback();
		},

		after: function() {
			this.checkVisibility();
		},

		checkVisibility: function() {
			if (this.properties.checkVisibility) {
				if (this.isVisible()) {
					this.$ctx.trigger('visible');
				}
				setTimeout($.proxy(this.checkVisibility, this), this.properties.interval);
			}
		},

		isVisible: function() {
			var mod = this,
				scrollOffset = mod.$ctx.offset().top,
				windowScrollOffset = $(window).scrollTop(),
				windowHeight = $(window).height();
			if (scrollOffset > 0 && scrollOffset < windowScrollOffset + windowHeight && mod.$ctx.is(':visible')) {
				return true;
			}
			return false;
		}
	});
	
}(Tc.$));
}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.LoadingIndicator.js
// module id = 153
// module chunks = 0